import { MutationTree, Mutation } from 'vuex'
import { IState, IMenuItem, IImagePopup } from './state'
import { ActionPayload } from './actions'

type MutationHandler<PayloadType> = (
  state: IState,
  payload: ActionPayload<PayloadType>
) => any

const initState: MutationHandler<IState> = (state, { payload }) => {
  Object.assign(state, payload)
}

const imagePopup: MutationHandler<IImagePopup> = (state, { payload }) => {
  const { hidden, src, caption, alt } = payload
  let imagePopup = {}
  if (hidden) {
    imagePopup = {
      hidden: hidden,
      src: '',
      caption: '',
      alt: ''
    }
  } else {
    imagePopup = {
      hidden,
      src,
      caption,
      alt
    }
  }
  Object.assign(state, { imagePopup })
}
const changeMenu: MutationHandler<any> = (state, { payload }) => {
  Object.assign(state, { showMenu: payload.action === 'show' })
}
const toggleMenuItem: MutationHandler<any> = (state, { payload }) => {
  const menuItem = state.menu.find((item: IMenuItem) => item.slug === payload)
  if (menuItem) menuItem.active = !menuItem.active
}
const setActiveMenuItem: MutationHandler<any> = (state, { payload }) => {
  state.menu.forEach(
    (item: IMenuItem) => (item.active = item.slug === payload.to.name)
  )
}

const mutations: MutationTree<IState> = {
  initState,
  imagePopup,
  changeMenu,
  toggleMenuItem,
  setActiveMenuItem
}

export default mutations
